/**
 * Servis taban yollari.
 *
 * `API_BASE_URL` (src/env.ts) zaten `/api` onekini koyuyor; buradakiler onun
 * uzerine binen SERVIS adlaridir. Tek yerde durmalari, bir ucun yanlis servise
 * yazilmasini derleme zamaninda gorunur kilar.
 */
export const IAM_BASE = '/dovizhub-iam-management';
export const CURRENCY_BASE = '/dovizhub-currency-management';
